import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

/** Search criteria for the device list. */
export type GitDeviceListFilter = {
  /** Partial device code to match. */
  code?: InputMaybe<Scalars['String']>;
  /** Device ID to retrieve. */
  id?: InputMaybe<Scalars['Int']>;
  /** Partial device name to match. */
  name?: InputMaybe<Scalars['String']>;
  /** Exact device model service category code to match. */
  serviceCategory?: InputMaybe<Scalars['String']>;
};

export type GtCharger = {
  __typename?: 'GTCharger';
  /** Charging connectors attached to this device. */
  connectors: Array<GtConnector>;
  /** Charger device ID. */
  deviceCode: Scalars['String'];
  /** Charger device ID. */
  idDevice: Scalars['Int'];
};

export type GtConnector = {
  __typename?: 'GTConnector';
  /** Current charging rate in watts. */
  chargeRateWatts: Scalars['Int'];
  /** Connector device code. */
  deviceCode: Scalars['String'];
  /** Connector device ID. */
  idDevice: Scalars['Int'];
  /** Is this connector currently charging? */
  isCharging: Scalars['Boolean'];
  /** Is this connector faulty? */
  isFault: Scalars['Boolean'];
  /** Is this connector currently plugged in to a vehicle? */
  isPlugged: Scalars['Boolean'];
  /** Connector ID/index reported by the EV charger. */
  ocppConnectorId: Scalars['Int'];
};

export type GtCoordinates = {
  __typename?: 'GTCoordinates';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type GtdbConnection = {
  __typename?: 'GTDBConnection';
  /** Application name provided by the code that initiated the connection.  This is the main indicator of why the connection exists. */
  application: Scalars['String'];
  /** Timestamp of when the connection was established. */
  connectedAt: Scalars['String'];
  /** Connection ID, suitable for passing to dbConnectionTerminate. */
  idConnection: Scalars['ID'];
  /** IP address of the connection origin. */
  ip: Scalars['String'];
  /** What the connection is currently doing. */
  state: Scalars['String'];
};

/** Details common to all device types. */
export type GtDevice = GtDeviceOrGateway & {
  __typename?: 'GTDevice';
  /** P&F-assigned device code. */
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  /** Short description about this device. */
  description?: Maybe<Scalars['String']>;
  /** Internal ID.  Use where possible to avoid issues when device codes are recycled. */
  id: Scalars['Int'];
  isMock?: Maybe<Scalars['String']>;
  lastError?: Maybe<GtDeviceError>;
  location?: Maybe<GtLocation>;
  model?: Maybe<GtDeviceModel>;
  modifiedAt?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  /** P&F-assigned descriptive name for this device. */
  name?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['String']>;
  reviewedBy?: Maybe<Scalars['String']>;
  status: GtDeviceStatus;
};

export type GtDeviceError = {
  __typename?: 'GTDeviceError';
  message: Scalars['String'];
  receivedDate: Scalars['String'];
  severity: GtSeverityEnum;
};

export type GtDeviceModel = {
  __typename?: 'GTDeviceModel';
  /** Manufacturer name. */
  brand: Scalars['String'];
  /** Identifier specifying which JS class to use to communicate with the device. */
  code: Scalars['String'];
  /** Model identifier (database primary key). */
  id: Scalars['Int'];
  /** Product name. */
  name: Scalars['String'];
  /** Service code for the class/category of device. */
  service: Scalars['String'];
  /** URL for the end-user to access to configure the device. */
  urlUser?: Maybe<Scalars['String']>;
};

/** Devices that might optionally be gateways too. */
export type GtDeviceOrGateway = {
  /** P&F-assigned device code. */
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  /** Short description about this device. */
  description?: Maybe<Scalars['String']>;
  /** Internal ID.  Use where possible to avoid issues when device codes are recycled. */
  id: Scalars['Int'];
  isMock?: Maybe<Scalars['String']>;
  lastError?: Maybe<GtDeviceError>;
  location?: Maybe<GtLocation>;
  model?: Maybe<GtDeviceModel>;
  modifiedAt?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  /** P&F-assigned descriptive name for this device. */
  name?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['String']>;
  reviewedBy?: Maybe<Scalars['String']>;
  status: GtDeviceStatus;
};

export type GtDeviceStatus = {
  __typename?: 'GTDeviceStatus';
  id: Scalars['String'];
  name: Scalars['String'];
};

/** Details about a gateway device. */
export type GtGateway = GtDeviceOrGateway & {
  __typename?: 'GTGateway';
  /** P&F-assigned device code. */
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  dataOutlet?: Maybe<Scalars['String']>;
  /** Short description about this device. */
  description?: Maybe<Scalars['String']>;
  /** Internal ID.  Use where possible to avoid issues when device codes are recycled. */
  id: Scalars['Int'];
  ipv4Address?: Maybe<Scalars['String']>;
  ipv4Port?: Maybe<Scalars['Int']>;
  isMock?: Maybe<Scalars['String']>;
  lastError?: Maybe<GtDeviceError>;
  location?: Maybe<GtLocation>;
  macAddress?: Maybe<Scalars['String']>;
  meters: Array<GtMeter>;
  model?: Maybe<GtDeviceModel>;
  modifiedAt?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  /** P&F-assigned descriptive name for this device. */
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['String']>;
  reviewedBy?: Maybe<Scalars['String']>;
  status: GtDeviceStatus;
  switchName?: Maybe<Scalars['String']>;
  switchPort?: Maybe<Scalars['String']>;
  /** Number of milliseconds between polling all the meters on the gateway.  Usually 60,000 which means the devices are read once a minute. */
  throttle?: Maybe<Scalars['Int']>;
  username?: Maybe<Scalars['String']>;
};

export type GtJob = {
  __typename?: 'GTJob';
  /** When the job started running, if it is running now (or crashed in the last run). */
  activeAt?: Maybe<Scalars['String']>;
  /** Database backend process ID, indicating the job is actively running. */
  activePID?: Maybe<Scalars['String']>;
  /** When the job is expected to complete.  If this date is in the past, the job has crashed. */
  anticipatedBy?: Maybe<Scalars['String']>;
  /** When the job was first created. */
  createdAt: Scalars['String'];
  /** How many times the job has failed with an error. */
  failureCount: Scalars['Int'];
  /** Job ID. */
  idJob: Scalars['Int'];
  /** Job ID that must complete before this one starts. */
  idJobWaitFor?: Maybe<Scalars['Int']>;
  /** Code indicating which job to run. */
  jobType: Scalars['String'];
  /** Last progress message supplied by the active job. */
  msgProgress?: Maybe<Scalars['String']>;
  /** JSON encoded string of job parameters.  Actual parameters differ depending on the job type. */
  parameters: Scalars['String'];
  /** Current job progress, 0..1 for 0% to 100% complete. */
  percentComplete: Scalars['Float'];
  /** Larger numbers will cause the job to be processed sooner, default is 0. */
  priority: Scalars['Int'];
  /** An optional future date to hold the job until. */
  runAfter?: Maybe<Scalars['String']>;
};

export type GtLocation = {
  __typename?: 'GTLocation';
  building?: Maybe<Scalars['String']>;
  buildingName?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  coordinates?: Maybe<GtCoordinates>;
  costRecovery?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  room?: Maybe<Scalars['String']>;
  site: Scalars['String'];
  siteName?: Maybe<Scalars['String']>;
  status: GtLocationStatus;
  zoom?: Maybe<Scalars['Int']>;
};

export type GtLocationStatus = {
  __typename?: 'GTLocationStatus';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GtLogMessage = {
  __typename?: 'GTLogMessage';
  /** Log category (debug prefix). */
  category: Scalars['String'];
  /** Timestamp of the log message. */
  dtLogged: Scalars['String'];
  /** Contents of the log message. */
  message: Scalars['String'];
};

/** Details about a meter device. */
export type GtMeter = {
  __typename?: 'GTMeter';
  /** P&F-assigned device code. */
  code: Scalars['String'];
  communicationType?: Maybe<Scalars['String']>;
  costRecovery?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  ctRatio?: Maybe<Scalars['String']>;
  /** Short description about this device. */
  description?: Maybe<Scalars['String']>;
  deviceAddress?: Maybe<Scalars['Int']>;
  /** Internal ID.  Use where possible to avoid issues when device codes are recycled. */
  id: Scalars['Int'];
  isInverted?: Maybe<Scalars['Boolean']>;
  isMock?: Maybe<Scalars['String']>;
  /** Is this device behind a Redlion?  If yes, the old standard Redlion Modbus register mapping is used, where the data types are passed through unchanged. */
  isRedlion?: Maybe<Scalars['Boolean']>;
  /** Is this device using the standard UQ Redlion float mapping?  If yes, the "uq-redlion-float" meter model is used to access this device, regardless of the actual meter model specified. */
  isRedlionFloat?: Maybe<Scalars['Boolean']>;
  lastError?: Maybe<GtDeviceError>;
  location?: Maybe<GtLocation>;
  model?: Maybe<GtDeviceModel>;
  modifiedAt?: Maybe<Scalars['String']>;
  modifiedBy?: Maybe<Scalars['String']>;
  /** P&F-assigned descriptive name for this device. */
  name?: Maybe<Scalars['String']>;
  reviewedAt?: Maybe<Scalars['String']>;
  reviewedBy?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  status: GtDeviceStatus;
};

/** Incomplete device/gateway/meter for updating existing devices. */
export type GtPartialDevice = {
  /** P&F-assigned device code. */
  code?: InputMaybe<Scalars['String']>;
  /** Communication protocol.  Not really used for anything. */
  communicationType?: InputMaybe<Scalars['String']>;
  /** True if someone is charged for use measured by this meter. */
  costRecovery?: InputMaybe<Scalars['Boolean']>;
  /** Current transformer ratio. */
  ctRatio?: InputMaybe<Scalars['String']>;
  /** Label on wall socket where device's Ethernet cable is plugged in. */
  dataOutlet?: InputMaybe<Scalars['String']>;
  /** Short description about this device. */
  description?: InputMaybe<Scalars['String']>;
  /** Numeric device address.  For Modbus devices, this is the Modbus device address. */
  deviceAddress?: InputMaybe<Scalars['Int']>;
  /** IPv4 address used for reading metrics. */
  ipv4Address?: InputMaybe<Scalars['String']>;
  /** Port used for reading metrics (TCP or UDP depends on protocol in use). */
  ipv4Port?: InputMaybe<Scalars['String']>;
  /** True if this meter is backwards, and import/export values need to be swapped. */
  isInverted?: InputMaybe<Scalars['Boolean']>;
  /** True if this is a mock device (only used by test environment), false for real device (only used in production environment). */
  isMock?: InputMaybe<Scalars['Boolean']>;
  /** Is this device behind a Redlion?  If yes, the old standard Redlion Modbus register mapping is used, where the data types are passed through unchanged. */
  isRedlion?: InputMaybe<Scalars['Boolean']>;
  /** True if this meter is using the Redlion float register set. */
  isRedlionFloat?: InputMaybe<Scalars['Boolean']>;
  /** Location ID indicating where this device is physically found. */
  location?: InputMaybe<Scalars['Int']>;
  /** MAC address of active Ethernet interface. */
  macAddress?: InputMaybe<Scalars['String']>;
  /** Device model ID. */
  model?: InputMaybe<Scalars['Int']>;
  /** P&F-assigned descriptive name for this device. */
  name?: InputMaybe<Scalars['String']>;
  /** Password to use when accessing device configuration interface (e.g. web page). */
  password?: InputMaybe<Scalars['String']>;
  /** Product serial number. */
  serialNumber?: InputMaybe<Scalars['String']>;
  /** Device status ID. */
  status?: InputMaybe<Scalars['String']>;
  /** Identifying name of Ethernet switch connected to the other end of the Ethernet wall socket that the device is plugged in to. */
  switchName?: InputMaybe<Scalars['String']>;
  /** ID of switch port.  Value depends on switch model and configuration */
  switchPort?: InputMaybe<Scalars['String']>;
  /** Number of milliseconds between polling all the meters on the gateway.  Usually 60,000 which means the devices are read once a minute. */
  throttle?: InputMaybe<Scalars['Int']>;
  /** Username to use when accessing device configuration interface (e.g. web page). */
  username?: InputMaybe<Scalars['String']>;
};

export enum GtSeverityEnum {
  /** This is only informative, and action may not be needed. */
  Adv = 'ADV',
  /** This is crucially important and requires an immediate fix. */
  Cri = 'CRI',
  /** This is important enough that it must be fixed, but it is not urgent. */
  Imp = 'IMP'
}

export type GtWebsocketConnection = {
  __typename?: 'GTWebsocketConnection';
  /** Application name provided by the code that initiated the connection.  This is the main indicator of why the connection exists. */
  application: Scalars['String'];
  /** Array of device codes this connection is subscribed to. */
  deviceCodes: Array<Scalars['String']>;
  /** AWS Websocket Connection ID. */
  idConnection: Scalars['ID'];
  /** IP address of the connection origin. */
  sourceIP: Scalars['String'];
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  collectorRefreshDevices?: Maybe<Scalars['Boolean']>;
  deviceUpdate?: Maybe<Scalars['Boolean']>;
  jobNew?: Maybe<Scalars['Int']>;
  jobPoll?: Maybe<Scalars['Boolean']>;
  jobRetry?: Maybe<Scalars['Boolean']>;
  terminateDatabaseConnection?: Maybe<Scalars['Boolean']>;
};


export type RootMutationTypeDeviceUpdateArgs = {
  deviceInfo: GtPartialDevice;
  idDevice?: InputMaybe<Scalars['Int']>;
};


export type RootMutationTypeJobNewArgs = {
  idJobWaitFor?: InputMaybe<Scalars['Int']>;
  jobType: Scalars['String'];
  parameters?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  runAfter?: InputMaybe<Scalars['String']>;
};


export type RootMutationTypeJobRetryArgs = {
  idJob: Scalars['Int'];
};


export type RootMutationTypeTerminateDatabaseConnectionArgs = {
  idConnection: Scalars['ID'];
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  chargerStatus: Array<GtCharger>;
  /** Obtain a list of active connections to the Websocket behind the dashboards. */
  dashboardViewers: Array<GtWebsocketConnection>;
  databaseConnections: Array<GtdbConnection>;
  /** Retrieve detailed information about a specific device. */
  deviceDetail: Array<GtDeviceOrGateway>;
  /** Retrieve a list of devices matching the given criteria. */
  deviceList: Array<GtDeviceOrGateway>;
  jobs: Array<GtJob>;
  /** Obtain recent logs from various system components. */
  logs: Array<GtLogMessage>;
  ping?: Maybe<Scalars['String']>;
};


export type RootQueryTypeDeviceDetailArgs = {
  idDevices: Array<InputMaybe<Scalars['Int']>>;
};


export type RootQueryTypeDeviceListArgs = {
  filter: GitDeviceListFilter;
};


export type RootQueryTypeLogsArgs = {
  idDevice: Scalars['Int'];
  source: Scalars['String'];
};

export type CollectorDeviceRefreshMutationVariables = Exact<{ [key: string]: never; }>;


export type CollectorDeviceRefreshMutation = { __typename?: 'RootMutationType', collectorRefreshDevices?: boolean | null };

export type DatabaseConnectionListQueryVariables = Exact<{ [key: string]: never; }>;


export type DatabaseConnectionListQuery = { __typename?: 'RootQueryType', databaseConnections: Array<{ __typename?: 'GTDBConnection', idConnection: string, ip: string, state: string, connectedAt: string, application: string }> };

export type DatabaseTerminateConnectionMutationVariables = Exact<{
  idConnection: Scalars['ID'];
}>;


export type DatabaseTerminateConnectionMutation = { __typename?: 'RootMutationType', terminateDatabaseConnection?: boolean | null };

export type DeviceLogsQueryVariables = Exact<{
  source: Scalars['String'];
  idDevice: Scalars['Int'];
}>;


export type DeviceLogsQuery = { __typename?: 'RootQueryType', logs: Array<{ __typename?: 'GTLogMessage', dtLogged: string, category: string, message: string }> };

export type DeviceSearchQueryVariables = Exact<{
  filter: GitDeviceListFilter;
}>;


export type DeviceSearchQuery = { __typename?: 'RootQueryType', deviceList: Array<{ __typename?: 'GTDevice', id: number, code: string, name?: string | null, lastError?: { __typename?: 'GTDeviceError', severity: GtSeverityEnum } | null } | { __typename?: 'GTGateway', id: number, code: string, name?: string | null, meters: Array<{ __typename?: 'GTMeter', id: number, code: string, name?: string | null, lastError?: { __typename?: 'GTDeviceError', severity: GtSeverityEnum } | null }>, lastError?: { __typename?: 'GTDeviceError', severity: GtSeverityEnum } | null }> };

export type DeviceViewQueryVariables = Exact<{
  idDevices: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type DeviceViewQuery = { __typename?: 'RootQueryType', deviceDetail: Array<{ __typename?: 'GTDevice', id: number, code: string, name?: string | null, description?: string | null, isMock?: string | null, status: { __typename?: 'GTDeviceStatus', id: string }, model?: { __typename?: 'GTDeviceModel', brand: string, name: string, urlUser?: string | null } | null, location?: { __typename?: 'GTLocation', id: number, code: string, name?: string | null, site: string, siteName?: string | null, building?: string | null, buildingName?: string | null, floor?: string | null, room?: string | null, zoom?: number | null, costRecovery?: boolean | null, coordinates?: { __typename?: 'GTCoordinates', latitude: number, longitude: number } | null, status: { __typename?: 'GTLocationStatus', id: string, name: string } } | null, lastError?: { __typename?: 'GTDeviceError', receivedDate: string, severity: GtSeverityEnum, message: string } | null } | { __typename?: 'GTGateway', ipv4Address?: string | null, ipv4Port?: number | null, macAddress?: string | null, username?: string | null, password?: string | null, dataOutlet?: string | null, throttle?: number | null, switchName?: string | null, switchPort?: string | null, id: number, code: string, name?: string | null, description?: string | null, isMock?: string | null, model?: { __typename?: 'GTDeviceModel', brand: string, name: string, urlUser?: string | null } | null, meters: Array<{ __typename?: 'GTMeter', id: number, code: string, name?: string | null, description?: string | null, isMock?: string | null, status: { __typename?: 'GTDeviceStatus', id: string }, model?: { __typename?: 'GTDeviceModel', brand: string, name: string } | null, location?: { __typename?: 'GTLocation', id: number, code: string, name?: string | null, site: string, siteName?: string | null, building?: string | null, buildingName?: string | null, floor?: string | null, room?: string | null, zoom?: number | null, costRecovery?: boolean | null, coordinates?: { __typename?: 'GTCoordinates', latitude: number, longitude: number } | null, status: { __typename?: 'GTLocationStatus', id: string, name: string } } | null, lastError?: { __typename?: 'GTDeviceError', severity: GtSeverityEnum, message: string } | null }>, status: { __typename?: 'GTDeviceStatus', id: string }, location?: { __typename?: 'GTLocation', id: number, code: string, name?: string | null, site: string, siteName?: string | null, building?: string | null, buildingName?: string | null, floor?: string | null, room?: string | null, zoom?: number | null, costRecovery?: boolean | null, coordinates?: { __typename?: 'GTCoordinates', latitude: number, longitude: number } | null, status: { __typename?: 'GTLocationStatus', id: string, name: string } } | null, lastError?: { __typename?: 'GTDeviceError', receivedDate: string, severity: GtSeverityEnum, message: string } | null }> };

export type DeviceUpdateMutationVariables = Exact<{
  idDevice: Scalars['Int'];
  deviceInfo: GtPartialDevice;
}>;


export type DeviceUpdateMutation = { __typename?: 'RootMutationType', deviceUpdate?: boolean | null };

export type EvChargerStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type EvChargerStatusQuery = { __typename?: 'RootQueryType', chargerStatus: Array<{ __typename?: 'GTCharger', idDevice: number, deviceCode: string, connectors: Array<{ __typename?: 'GTConnector', idDevice: number, deviceCode: string, ocppConnectorId: number, isFault: boolean, isCharging: boolean, isPlugged: boolean, chargeRateWatts: number }> }> };

export type JobListQueryVariables = Exact<{ [key: string]: never; }>;


export type JobListQuery = { __typename?: 'RootQueryType', jobs: Array<{ __typename?: 'GTJob', idJob: number, jobType: string, priority: number, idJobWaitFor?: number | null, parameters: string, createdAt: string, runAfter?: string | null, activeAt?: string | null, activePID?: string | null, msgProgress?: string | null, percentComplete: number, anticipatedBy?: string | null, failureCount: number }> };

export type JobRetryMutationVariables = Exact<{
  idJob: Scalars['Int'];
}>;


export type JobRetryMutation = { __typename?: 'RootMutationType', jobRetry?: boolean | null };

export type JobPollMutationVariables = Exact<{ [key: string]: never; }>;


export type JobPollMutation = { __typename?: 'RootMutationType', jobPoll?: boolean | null };

export type JobNewMutationVariables = Exact<{
  jobType: Scalars['String'];
  priority?: InputMaybe<Scalars['Int']>;
  parameters?: InputMaybe<Scalars['String']>;
  runAfter?: InputMaybe<Scalars['String']>;
  idJobWaitFor?: InputMaybe<Scalars['Int']>;
}>;


export type JobNewMutation = { __typename?: 'RootMutationType', jobNew?: number | null };

export type WebsocketConnectionListQueryVariables = Exact<{ [key: string]: never; }>;


export type WebsocketConnectionListQuery = { __typename?: 'RootQueryType', dashboardViewers: Array<{ __typename?: 'GTWebsocketConnection', idConnection: string, sourceIP: string, deviceCodes: Array<string>, application: string }> };


export const CollectorDeviceRefreshDocument = gql`
    mutation CollectorDeviceRefresh {
  collectorRefreshDevices
}
    `;
export type CollectorDeviceRefreshMutationFn = Apollo.MutationFunction<CollectorDeviceRefreshMutation, CollectorDeviceRefreshMutationVariables>;

/**
 * __useCollectorDeviceRefreshMutation__
 *
 * To run a mutation, you first call `useCollectorDeviceRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectorDeviceRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectorDeviceRefreshMutation, { data, loading, error }] = useCollectorDeviceRefreshMutation({
 *   variables: {
 *   },
 * });
 */
export function useCollectorDeviceRefreshMutation(baseOptions?: Apollo.MutationHookOptions<CollectorDeviceRefreshMutation, CollectorDeviceRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CollectorDeviceRefreshMutation, CollectorDeviceRefreshMutationVariables>(CollectorDeviceRefreshDocument, options);
      }
export type CollectorDeviceRefreshMutationHookResult = ReturnType<typeof useCollectorDeviceRefreshMutation>;
export type CollectorDeviceRefreshMutationResult = Apollo.MutationResult<CollectorDeviceRefreshMutation>;
export type CollectorDeviceRefreshMutationOptions = Apollo.BaseMutationOptions<CollectorDeviceRefreshMutation, CollectorDeviceRefreshMutationVariables>;
export const DatabaseConnectionListDocument = gql`
    query DatabaseConnectionList {
  databaseConnections {
    idConnection
    ip
    state
    connectedAt
    application
  }
}
    `;

/**
 * __useDatabaseConnectionListQuery__
 *
 * To run a query within a React component, call `useDatabaseConnectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatabaseConnectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatabaseConnectionListQuery({
 *   variables: {
 *   },
 * });
 */
export function useDatabaseConnectionListQuery(baseOptions?: Apollo.QueryHookOptions<DatabaseConnectionListQuery, DatabaseConnectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatabaseConnectionListQuery, DatabaseConnectionListQueryVariables>(DatabaseConnectionListDocument, options);
      }
export function useDatabaseConnectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatabaseConnectionListQuery, DatabaseConnectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatabaseConnectionListQuery, DatabaseConnectionListQueryVariables>(DatabaseConnectionListDocument, options);
        }
export type DatabaseConnectionListQueryHookResult = ReturnType<typeof useDatabaseConnectionListQuery>;
export type DatabaseConnectionListLazyQueryHookResult = ReturnType<typeof useDatabaseConnectionListLazyQuery>;
export type DatabaseConnectionListQueryResult = Apollo.QueryResult<DatabaseConnectionListQuery, DatabaseConnectionListQueryVariables>;
export const DatabaseTerminateConnectionDocument = gql`
    mutation DatabaseTerminateConnection($idConnection: ID!) {
  terminateDatabaseConnection(idConnection: $idConnection)
}
    `;
export type DatabaseTerminateConnectionMutationFn = Apollo.MutationFunction<DatabaseTerminateConnectionMutation, DatabaseTerminateConnectionMutationVariables>;

/**
 * __useDatabaseTerminateConnectionMutation__
 *
 * To run a mutation, you first call `useDatabaseTerminateConnectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDatabaseTerminateConnectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [databaseTerminateConnectionMutation, { data, loading, error }] = useDatabaseTerminateConnectionMutation({
 *   variables: {
 *      idConnection: // value for 'idConnection'
 *   },
 * });
 */
export function useDatabaseTerminateConnectionMutation(baseOptions?: Apollo.MutationHookOptions<DatabaseTerminateConnectionMutation, DatabaseTerminateConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DatabaseTerminateConnectionMutation, DatabaseTerminateConnectionMutationVariables>(DatabaseTerminateConnectionDocument, options);
      }
export type DatabaseTerminateConnectionMutationHookResult = ReturnType<typeof useDatabaseTerminateConnectionMutation>;
export type DatabaseTerminateConnectionMutationResult = Apollo.MutationResult<DatabaseTerminateConnectionMutation>;
export type DatabaseTerminateConnectionMutationOptions = Apollo.BaseMutationOptions<DatabaseTerminateConnectionMutation, DatabaseTerminateConnectionMutationVariables>;
export const DeviceLogsDocument = gql`
    query DeviceLogs($source: String!, $idDevice: Int!) {
  logs(source: $source, idDevice: $idDevice) {
    dtLogged
    category
    message
  }
}
    `;

/**
 * __useDeviceLogsQuery__
 *
 * To run a query within a React component, call `useDeviceLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceLogsQuery({
 *   variables: {
 *      source: // value for 'source'
 *      idDevice: // value for 'idDevice'
 *   },
 * });
 */
export function useDeviceLogsQuery(baseOptions: Apollo.QueryHookOptions<DeviceLogsQuery, DeviceLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceLogsQuery, DeviceLogsQueryVariables>(DeviceLogsDocument, options);
      }
export function useDeviceLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceLogsQuery, DeviceLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceLogsQuery, DeviceLogsQueryVariables>(DeviceLogsDocument, options);
        }
export type DeviceLogsQueryHookResult = ReturnType<typeof useDeviceLogsQuery>;
export type DeviceLogsLazyQueryHookResult = ReturnType<typeof useDeviceLogsLazyQuery>;
export type DeviceLogsQueryResult = Apollo.QueryResult<DeviceLogsQuery, DeviceLogsQueryVariables>;
export const DeviceSearchDocument = gql`
    query DeviceSearch($filter: GITDeviceListFilter!) {
  deviceList(filter: $filter) {
    id
    code
    name
    lastError {
      severity
    }
    ... on GTGateway {
      meters {
        id
        code
        name
        lastError {
          severity
        }
      }
    }
  }
}
    `;

/**
 * __useDeviceSearchQuery__
 *
 * To run a query within a React component, call `useDeviceSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceSearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDeviceSearchQuery(baseOptions: Apollo.QueryHookOptions<DeviceSearchQuery, DeviceSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceSearchQuery, DeviceSearchQueryVariables>(DeviceSearchDocument, options);
      }
export function useDeviceSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceSearchQuery, DeviceSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceSearchQuery, DeviceSearchQueryVariables>(DeviceSearchDocument, options);
        }
export type DeviceSearchQueryHookResult = ReturnType<typeof useDeviceSearchQuery>;
export type DeviceSearchLazyQueryHookResult = ReturnType<typeof useDeviceSearchLazyQuery>;
export type DeviceSearchQueryResult = Apollo.QueryResult<DeviceSearchQuery, DeviceSearchQueryVariables>;
export const DeviceViewDocument = gql`
    query DeviceView($idDevices: [Int]!) {
  deviceDetail(idDevices: $idDevices) {
    id
    code
    name
    description
    status {
      id
    }
    isMock
    model {
      brand
      name
      urlUser
    }
    location {
      id
      code
      name
      site
      siteName
      building
      buildingName
      floor
      room
      coordinates {
        latitude
        longitude
      }
      zoom
      costRecovery
      status {
        id
        name
      }
    }
    lastError {
      receivedDate
      severity
      message
    }
    ... on GTGateway {
      ipv4Address
      ipv4Port
      macAddress
      username
      password
      dataOutlet
      throttle
      switchName
      switchPort
      model {
        brand
        name
        urlUser
      }
      meters {
        id
        code
        name
        description
        status {
          id
        }
        isMock
        model {
          brand
          name
        }
        location {
          id
          code
          name
          site
          siteName
          building
          buildingName
          floor
          room
          coordinates {
            latitude
            longitude
          }
          zoom
          costRecovery
          status {
            id
            name
          }
        }
        lastError {
          severity
          message
        }
      }
    }
  }
}
    `;

/**
 * __useDeviceViewQuery__
 *
 * To run a query within a React component, call `useDeviceViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeviceViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeviceViewQuery({
 *   variables: {
 *      idDevices: // value for 'idDevices'
 *   },
 * });
 */
export function useDeviceViewQuery(baseOptions: Apollo.QueryHookOptions<DeviceViewQuery, DeviceViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeviceViewQuery, DeviceViewQueryVariables>(DeviceViewDocument, options);
      }
export function useDeviceViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeviceViewQuery, DeviceViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeviceViewQuery, DeviceViewQueryVariables>(DeviceViewDocument, options);
        }
export type DeviceViewQueryHookResult = ReturnType<typeof useDeviceViewQuery>;
export type DeviceViewLazyQueryHookResult = ReturnType<typeof useDeviceViewLazyQuery>;
export type DeviceViewQueryResult = Apollo.QueryResult<DeviceViewQuery, DeviceViewQueryVariables>;
export const DeviceUpdateDocument = gql`
    mutation DeviceUpdate($idDevice: Int!, $deviceInfo: GTPartialDevice!) {
  deviceUpdate(idDevice: $idDevice, deviceInfo: $deviceInfo)
}
    `;
export type DeviceUpdateMutationFn = Apollo.MutationFunction<DeviceUpdateMutation, DeviceUpdateMutationVariables>;

/**
 * __useDeviceUpdateMutation__
 *
 * To run a mutation, you first call `useDeviceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeviceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deviceUpdateMutation, { data, loading, error }] = useDeviceUpdateMutation({
 *   variables: {
 *      idDevice: // value for 'idDevice'
 *      deviceInfo: // value for 'deviceInfo'
 *   },
 * });
 */
export function useDeviceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DeviceUpdateMutation, DeviceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeviceUpdateMutation, DeviceUpdateMutationVariables>(DeviceUpdateDocument, options);
      }
export type DeviceUpdateMutationHookResult = ReturnType<typeof useDeviceUpdateMutation>;
export type DeviceUpdateMutationResult = Apollo.MutationResult<DeviceUpdateMutation>;
export type DeviceUpdateMutationOptions = Apollo.BaseMutationOptions<DeviceUpdateMutation, DeviceUpdateMutationVariables>;
export const EvChargerStatusDocument = gql`
    query EVChargerStatus {
  chargerStatus {
    idDevice
    deviceCode
    connectors {
      idDevice
      deviceCode
      ocppConnectorId
      isFault
      isCharging
      isPlugged
      chargeRateWatts
    }
  }
}
    `;

/**
 * __useEvChargerStatusQuery__
 *
 * To run a query within a React component, call `useEvChargerStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useEvChargerStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEvChargerStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useEvChargerStatusQuery(baseOptions?: Apollo.QueryHookOptions<EvChargerStatusQuery, EvChargerStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EvChargerStatusQuery, EvChargerStatusQueryVariables>(EvChargerStatusDocument, options);
      }
export function useEvChargerStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EvChargerStatusQuery, EvChargerStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EvChargerStatusQuery, EvChargerStatusQueryVariables>(EvChargerStatusDocument, options);
        }
export type EvChargerStatusQueryHookResult = ReturnType<typeof useEvChargerStatusQuery>;
export type EvChargerStatusLazyQueryHookResult = ReturnType<typeof useEvChargerStatusLazyQuery>;
export type EvChargerStatusQueryResult = Apollo.QueryResult<EvChargerStatusQuery, EvChargerStatusQueryVariables>;
export const JobListDocument = gql`
    query JobList {
  jobs {
    idJob
    jobType
    priority
    idJobWaitFor
    parameters
    createdAt
    runAfter
    activeAt
    activePID
    msgProgress
    percentComplete
    anticipatedBy
    failureCount
  }
}
    `;

/**
 * __useJobListQuery__
 *
 * To run a query within a React component, call `useJobListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobListQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobListQuery(baseOptions?: Apollo.QueryHookOptions<JobListQuery, JobListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobListQuery, JobListQueryVariables>(JobListDocument, options);
      }
export function useJobListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobListQuery, JobListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobListQuery, JobListQueryVariables>(JobListDocument, options);
        }
export type JobListQueryHookResult = ReturnType<typeof useJobListQuery>;
export type JobListLazyQueryHookResult = ReturnType<typeof useJobListLazyQuery>;
export type JobListQueryResult = Apollo.QueryResult<JobListQuery, JobListQueryVariables>;
export const JobRetryDocument = gql`
    mutation JobRetry($idJob: Int!) {
  jobRetry(idJob: $idJob)
}
    `;
export type JobRetryMutationFn = Apollo.MutationFunction<JobRetryMutation, JobRetryMutationVariables>;

/**
 * __useJobRetryMutation__
 *
 * To run a mutation, you first call `useJobRetryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobRetryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobRetryMutation, { data, loading, error }] = useJobRetryMutation({
 *   variables: {
 *      idJob: // value for 'idJob'
 *   },
 * });
 */
export function useJobRetryMutation(baseOptions?: Apollo.MutationHookOptions<JobRetryMutation, JobRetryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobRetryMutation, JobRetryMutationVariables>(JobRetryDocument, options);
      }
export type JobRetryMutationHookResult = ReturnType<typeof useJobRetryMutation>;
export type JobRetryMutationResult = Apollo.MutationResult<JobRetryMutation>;
export type JobRetryMutationOptions = Apollo.BaseMutationOptions<JobRetryMutation, JobRetryMutationVariables>;
export const JobPollDocument = gql`
    mutation JobPoll {
  jobPoll
}
    `;
export type JobPollMutationFn = Apollo.MutationFunction<JobPollMutation, JobPollMutationVariables>;

/**
 * __useJobPollMutation__
 *
 * To run a mutation, you first call `useJobPollMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobPollMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobPollMutation, { data, loading, error }] = useJobPollMutation({
 *   variables: {
 *   },
 * });
 */
export function useJobPollMutation(baseOptions?: Apollo.MutationHookOptions<JobPollMutation, JobPollMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobPollMutation, JobPollMutationVariables>(JobPollDocument, options);
      }
export type JobPollMutationHookResult = ReturnType<typeof useJobPollMutation>;
export type JobPollMutationResult = Apollo.MutationResult<JobPollMutation>;
export type JobPollMutationOptions = Apollo.BaseMutationOptions<JobPollMutation, JobPollMutationVariables>;
export const JobNewDocument = gql`
    mutation JobNew($jobType: String!, $priority: Int, $parameters: String, $runAfter: String, $idJobWaitFor: Int) {
  jobNew(
    jobType: $jobType
    priority: $priority
    parameters: $parameters
    runAfter: $runAfter
    idJobWaitFor: $idJobWaitFor
  )
}
    `;
export type JobNewMutationFn = Apollo.MutationFunction<JobNewMutation, JobNewMutationVariables>;

/**
 * __useJobNewMutation__
 *
 * To run a mutation, you first call `useJobNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobNewMutation, { data, loading, error }] = useJobNewMutation({
 *   variables: {
 *      jobType: // value for 'jobType'
 *      priority: // value for 'priority'
 *      parameters: // value for 'parameters'
 *      runAfter: // value for 'runAfter'
 *      idJobWaitFor: // value for 'idJobWaitFor'
 *   },
 * });
 */
export function useJobNewMutation(baseOptions?: Apollo.MutationHookOptions<JobNewMutation, JobNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobNewMutation, JobNewMutationVariables>(JobNewDocument, options);
      }
export type JobNewMutationHookResult = ReturnType<typeof useJobNewMutation>;
export type JobNewMutationResult = Apollo.MutationResult<JobNewMutation>;
export type JobNewMutationOptions = Apollo.BaseMutationOptions<JobNewMutation, JobNewMutationVariables>;
export const WebsocketConnectionListDocument = gql`
    query WebsocketConnectionList {
  dashboardViewers {
    idConnection
    sourceIP
    deviceCodes
    application
  }
}
    `;

/**
 * __useWebsocketConnectionListQuery__
 *
 * To run a query within a React component, call `useWebsocketConnectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsocketConnectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsocketConnectionListQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebsocketConnectionListQuery(baseOptions?: Apollo.QueryHookOptions<WebsocketConnectionListQuery, WebsocketConnectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsocketConnectionListQuery, WebsocketConnectionListQueryVariables>(WebsocketConnectionListDocument, options);
      }
export function useWebsocketConnectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsocketConnectionListQuery, WebsocketConnectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsocketConnectionListQuery, WebsocketConnectionListQueryVariables>(WebsocketConnectionListDocument, options);
        }
export type WebsocketConnectionListQueryHookResult = ReturnType<typeof useWebsocketConnectionListQuery>;
export type WebsocketConnectionListLazyQueryHookResult = ReturnType<typeof useWebsocketConnectionListLazyQuery>;
export type WebsocketConnectionListQueryResult = Apollo.QueryResult<WebsocketConnectionListQuery, WebsocketConnectionListQueryVariables>;